import { Clock3, RefreshCw } from 'lucide-react';
import { formatBillingDate } from './billingData';

export default function PaymentCancellationNotice({ requestedAt, busy, feedback, onRefresh, english = false }) {
  return <section className="billing-cancellation" aria-label={english ? 'Cancellation progress' : '取消进度'}>
    <Clock3 className="billing-cancellation__icon" size={17} aria-hidden="true" />
    <div className="billing-cancellation__content">
      <div className="billing-cancellation__heading">
        <strong>{english ? 'Cancellation request submitted' : '取消申请已提交'}</strong>
        {requestedAt && <time dateTime={requestedAt}>{english ? 'Submitted ' : '申请于 '}{formatBillingDate(requestedAt, { locale: english ? 'en-US' : 'zh-CN' })}</time>}
      </div>
      <p>{english ? 'Waiting for Alipay to confirm closure. Please do not use the original payment link.' : '正在等待支付宝确认关闭交易，请勿再使用原付款入口。'}</p>
      <p className="billing-cancellation__hint">{english ? 'Confirmation may take some time. Refresh to check the result; any completed payment will be shown accurately.' : '确认可能需要一段时间，可刷新查看结果；若已付款，将按实际支付结果更新。'}</p>
      {feedback?.message && <p className={`billing-cancellation__feedback is-${feedback.type}`} role={feedback.type === 'error' ? 'alert' : 'status'}>{feedback.message}</p>}
    </div>
    <button type="button" className="billing-cancellation__refresh" disabled={busy} onClick={onRefresh}>
      <RefreshCw size={12} className={busy ? 'is-spinning' : ''} aria-hidden="true" />
      {busy ? (english ? 'Checking…' : '正在核对…') : (english ? 'Refresh status' : '刷新状态')}
    </button>
  </section>;
}
